import React, { useEffect } from 'react';
import { useMenu } from 'react-instantsearch';

import { FilterSection } from '@sorare/core/src/components/search/FilterSection';
import { Option } from '@sorare/core/src/components/search/Option';
import { useMenu as useBackendMenu } from '@sorare/core/src/contexts/graphql-search';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { MENU } from '@sorare/core/src/lib/filters';

const { attribute } = MENU.revealableCardCampaign;

const Radio = () => {
  const { items, refine } = useMenu({ attribute });

  useEffect(() => {
    // filter on the campaign with the most cards
    if (items.length > 0 && !items.some(item => item.isRefined)) {
      const item = items.reduce((acc, i) => {
        return acc.count > i.count ? acc : i;
      }, items[0]);
      refine(item.value);
    }
  }, [items, refine]);

  if (items.length === 0) {
    return null;
  }

  return (
    <FilterSection>
      {items.map(item => (
        <Option
          key={item.value}
          active={item.isRefined}
          onClick={() => refine(item.value)}
          variant="radio"
          count={item.count}
        >
          {item.label}
        </Option>
      ))}
    </FilterSection>
  );
};

export const RevealableCardCampaignMenu: FilterWidget = {
  key: MENU.revealableCardCampaign.attribute,
  type: 'menu',
  attribute: MENU.revealableCardCampaign.attribute,
  Component: () => <Radio />,
};

const BackendRadio = () => {
  const { items, value, refine } = useBackendMenu('rcc');

  useEffect(() => {
    if (items.length > 0 && !value) {
      const top = items.reduce(
        (acc, i) => (acc.count > i.count ? acc : i),
        items[0]
      );
      refine(top.value);
    }
  }, [items, value, refine]);

  if (items.length === 0) return null;

  return (
    <FilterSection>
      {items.map(item => (
        <Option
          key={item.value}
          active={item.isRefined}
          onClick={() => refine(item.value)}
          variant="radio"
          count={item.count}
        >
          {item.label}
        </Option>
      ))}
    </FilterSection>
  );
};

export const BackendRevealableCardCampaignMenu: FilterWidget = {
  key: 'rcc',
  type: 'menu',
  attribute: 'rcc',
  Component: () => <BackendRadio />,
};
